var _path, _g, _path2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgListNone = function SvgListNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 77,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "list_none_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 61,
    height: 76
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m50.123 11.716 3.995-10.512L.455 7.234 8.27 76.795l50.682-5.694 1.641-12.26-5.78-5.389 4.496-6.04-9.543-12.009 7.143-9.356-3.372-3.143 2.479-4.807-5.893-6.382Z",
    fill: "#000"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#list_none_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m-23.88 14.1 87.45-9.825.446 3.975-5.963.67.67 5.963 5.963-.67 4.466 39.75-5.963.67.67 5.962 5.963-.67.446 3.975-87.45 9.825-.446-3.975 4.969-.558-.67-5.963-4.97.558-4.465-39.75 4.969-.558-.67-5.962-4.969.558-.446-3.975Zm17.34 2.077-6.956.782.67 5.962 6.956-.781-.67-5.963Zm4.969-.558 6.956-.782.67 5.963-6.957.781-.67-5.962Zm18.88-2.121-6.955.781.67 5.962 6.956-.781-.67-5.963Zm4.97-.559 6.956-.781.67 5.962-6.957.782-.67-5.963Zm18.88-2.121-6.956.782.67 5.962 6.957-.782-.67-5.962Zm4.97-.558 6.956-.782.67 5.963-6.957.781-.67-5.962ZM-1.404 61.89l-6.957.78.67 5.963 6.956-.781-.67-5.963Zm4.968-.559 6.957-.781.67 5.962-6.957.782-.67-5.963Zm18.882-2.121-6.957.781.67 5.963 6.956-.782-.67-5.962Zm4.968-.558 6.956-.782.67 5.963-6.956.781-.67-5.962Zm18.881-2.122-6.956.782.67 5.962 6.956-.781-.67-5.963Zm4.97-.558 6.956-.781.67 5.962-6.957.782-.67-5.963Z",
    fill: "#23221F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "list_none_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 0,
    width: 62,
    height: 76
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64.646 10.265 6.19-9.387 49.709 5.39-7.547 69.593-52.691-5.715 4.276-11.606-4.466-6.52 5.706-4.913-6.694-13.802 9.012-7.573-2.605-3.803 3.468-4.15-4.358-7.514Z",
    fill: "#000"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#list_none_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m26.446 2.099 87.487 9.488-.431 3.976-5.965-.646-.647 5.965 5.965.646-4.313 39.767-5.965-.647-.647 5.965 5.965.647-.431 3.977-87.487-9.488.431-3.976 4.971.539.647-5.965-4.97-.54 4.312-39.766 4.97.539.647-5.965-4.97-.54.43-3.976Zm16.47 5.81-6.96-.755-.647 5.965 6.96.755.647-5.965Zm4.97.539 6.96.754-.647 5.965-6.96-.754.647-5.965Zm18.89 2.048-6.96-.755-.646 5.966 6.959.754.647-5.965Zm4.97.54 6.96.754-.647 5.965-6.96-.755.647-5.965Zm18.89 2.048-6.96-.755-.646 5.965 6.959.755.647-5.965Zm4.97.539 6.96.755-.647 5.965-6.96-.755.648-5.965ZM37.957 53.64l-6.96-.754-.646 5.965 6.96.755.646-5.966Zm4.97.54 6.96.754-.647 5.965-6.959-.755.647-5.965Zm18.89 2.048-6.959-.755-.647 5.965 6.96.755.646-5.965Zm4.971.54 6.96.754-.648 5.965-6.959-.755.647-5.965Zm18.89 2.048-6.96-.755-.647 5.965 6.96.755.646-5.965Zm4.97.539 6.96.754-.648 5.965L90 65.32l.647-5.965Z",
    fill: "#23221F"
  }))));
};
export default SvgListNone;